module.exports = __webpack_public_path__ + "static/media/KMH_5288.1481bf6c.jpg";